// src/utils/permisos.js

// Diccionario centralizado de permisos SaaS
export const PERMISOS_SAAS = {
    CREAR_USUARIOS: 'crear_usuarios',
    EDITAR_PERMISOS: 'editar_permisos',
    APROBAR_NOMINA: 'aprobar_nomina',
    CREAR_EMPLEADOS: 'crear_empleados',
    EDITAR_EMPLEADOS: 'editar_empleados',
    ACCESO_MODULO_RH: 'acceso_modulo_rh',
    ACCESO_MODULO_NOMINA: 'acceso_modulo_nomina',
    ACCESO_MODULO_DISPERSION: 'acceso_modulo_dispersion',
    ACCESO_MODULO_CRM: 'acceso_modulo_crm',
    ACCESO_MODULO_CATALOGOS: 'acceso_modulo_catalogos',
    ACCESO_MODULO_MARKETPLACE: 'acceso_modulo_marketplace',
    APROBAR_PROVEEDORES: 'aprobar_proveedores',
    TIMBRAR_FACTURAS: 'timbrar_facturas',
    POSTEAR_JES: 'postear_jes', // Journal Entries
    ALTA_PROVEEDORES: 'alta_proveedores',
    EDITAR_CUENTAS_CATALOGO: 'editar_cuentas_catalogo',
    EDITAR_CRM: 'editar_crm',
    EDITAR_SERVICIOS: 'editar_servicios',
    EDITAR_TIERS_MARKETPLACE: 'editar_tiers_marketplace',
    EDITAR_CATEGORIAS_MARKETPLACE: 'editar_categorias_marketplace'
};

/**
 * Valida si un usuario posee el permiso especificado.
 * El superusuario asume tener sus accesos si no existen en el objeto (modo retrocompatibilidad) 
 * Sin embargo, se prioriza el chequeo booleano escrito en la Propiedad `permisos` del UserDoc.
 * 
 * @param {Object} userData - Documento del Usuario desde AuthContext
 * @param {String} permissionKey - Nombre del permiso a validar
 * @returns {Boolean}
 */
export const checkPermission = (userData, permissionKey) => {
    if (!userData) return false;

    // Omnipotencia del Masteruser (Fundador)
    if (userData.rol === 'masteruser') {
        return true;
    }

    // Si tiene la estructura de permisos formal
    if (userData.permisos && typeof userData.permisos === 'object') {
        return userData.permisos[permissionKey] === true;
    }

    // By-pass emergente por si el objeto aún no existe en la BD pero es un superuser hardcoded
    if (userData.rol === 'superuser') {
        return true; 
    }

    return false;
};
